import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ModalDesktop as Modal } from '@alfalab/core-components-modal/desktop';

import type { TFooterProps, IFooterDeps } from '../models';
import { Footer as Component } from '../footer';
import styles from '../../../modal/desktop/desktop.css';

export const ModalV2FooterDesktop = createWidget<IFooterDeps, TFooterProps>({
    Modal,
    styles,
})(Component);
